import api from './api';

const takataApi = {
  // ─── Dossiers ────────────────────────────────────────────────────────────
  getDossiers: (params) => api.get('/takata/dossiers', { params }),
  getDossier: (id) => api.get(`/takata/dossiers/${id}`),
  searchByImmat: (immat) => api.get('/takata/dossiers/search-immat', { params: { immat } }),
  createDossier: (data) => api.post('/takata/dossiers', data),
  updateDossier: (id, data) => api.put(`/takata/dossiers/${id}`, data),
  gelerDossier: (id) => api.post(`/takata/dossiers/${id}/geler`),
  deleteDossier: (id) => api.delete(`/takata/dossiers/${id}`),
  deleteDossiersBulk: (ids) => api.delete('/takata/dossiers', { data: { ids } }),
  updateStatutBulk: (ids, statut) => api.patch('/takata/dossiers/bulk-statut', { ids, statut }),
  updateBulk: (ids, fields) => api.patch('/takata/dossiers/bulk-update', { ids, fields }),
  patchAirbag: (id, data) => api.patch(`/takata/dossiers/${id}/airbag`, data),
  patchReporting: (id, data) => api.patch(`/takata/dossiers/${id}/reporting`, data),

  // ─── Contacts (immuables) ─────────────────────────────────────────────────
  getContacts: (dossierId) => api.get(`/takata/dossiers/${dossierId}/contacts`),
  getAllContacts: () => api.get('/takata/all-contacts'),
  addContact: (dossierId, data) => api.post(`/takata/dossiers/${dossierId}/contacts`, data),

  // ─── SMS Takata (Mobbiz) ──────────────────────────────────────────────────
  // payload : { modele_id, message } — message = texte final (rendu + édité).
  sendSmsTakata: (dossierId, payload) => api.post(`/takata/dossiers/${dossierId}/sms`, payload || {}),

  // Modèles de SMS (configurables) : lecture pour tous, écriture admin.
  getSmsModeles: () => api.get('/takata/sms-modeles'),
  createSmsModele: (data) => api.post('/takata/sms-modeles', data),
  updateSmsModele: (id, data) => api.put(`/takata/sms-modeles/${id}`, data),
  deleteSmsModele: (id) => api.delete(`/takata/sms-modeles/${id}`),

  // ─── RDV ─────────────────────────────────────────────────────────────────
  getRdv: (dossierId) => api.get(`/takata/dossiers/${dossierId}/rdv`),
  getAllRdv: () => api.get('/takata/all-rdv'),
  createRdv: (dossierId, data) => api.post(`/takata/dossiers/${dossierId}/rdv`, data),
  updateRdvStatut: (rdvId, data) => api.put(`/takata/rdv/${rdvId}`, data),

  // ─── Documents (S3) ───────────────────────────────────────────────────────
  getDocuments: (dossierId) => api.get(`/takata/dossiers/${dossierId}/documents`),
  presignDocument: (dossierId, data) => api.post(`/takata/dossiers/${dossierId}/documents/presign`, data),
  confirmDocument: (dossierId, data) => api.post(`/takata/dossiers/${dossierId}/documents/confirm`, data),
  getDocumentUrl: (docId) => api.get(`/takata/documents/${docId}/url`),
  renameDocument: (docId, nom) => api.put(`/takata/documents/${docId}/rename`, { nom }),
  deleteDocument: (dossierId, docId) => api.delete(`/takata/dossiers/${dossierId}/documents/${docId}`),

  // ─── Exports ──────────────────────────────────────────────────────────────
  getExportContacts: (params) => api.get('/takata/export/contacts', { params }),
  getExportClients: () => api.get('/takata/export/clients'),
  migrateClientsFromCourriers: () => api.post('/takata/migrate/clients-from-courriers'),

  // ─── Webapp détections ─────────────────────────────────────────────────────
  getWebappDetections: (params = {}) => api.get('/takata/webapp-detections', { params }),

  // ─── Prêt véhicule ────────────────────────────────────────────────────────
  getPrets: (dossierId) => api.get(`/takata/dossiers/${dossierId}/pret`),
  getAllPrets: () => api.get('/takata/all-prets'),
  createPret: (dossierId, data) => api.post(`/takata/dossiers/${dossierId}/pret`, data),
  updatePret: (dossierId, pretId, data) => api.put(`/takata/dossiers/${dossierId}/pret/${pretId}`, data),

  // ─── Escalades ────────────────────────────────────────────────────────────
  getEscalades: (dossierId) => api.get(`/takata/dossiers/${dossierId}/escalades`),
  createEscalade: (dossierId, data) => api.post(`/takata/dossiers/${dossierId}/escalades`, data),

  // ─── Courriers ────────────────────────────────────────────────────────────
  getCourriers: (dossierId) => api.get(`/takata/dossiers/${dossierId}/courriers`),
  createCourrier: (dossierId, data) => api.post(`/takata/dossiers/${dossierId}/courriers`, data),
  updateCourrier: (dossierId, courrierId, data) => api.put(`/takata/dossiers/${dossierId}/courriers/${courrierId}`, data),
  getAllCourriers: (params) => api.get('/takata/courriers', { params }),
  importMaileva: (file, modeEnvoi) => {
    const fd = new FormData();
    fd.append('file', file);
    if (modeEnvoi) fd.append('mode_envoi', modeEnvoi);
    return api.post('/takata/courriers/import', fd, { headers: { 'Content-Type': 'multipart/form-data' } });
  },

  // ─── Stocks airbags ───────────────────────────────────────────────────────
  getStocks: (params) => api.get('/takata/stocks', { params }),
  createStock: (data) => api.post('/takata/stocks', data),
  updateStock: (id, data) => api.put(`/takata/stocks/${id}`, data),
  deleteStock: (id) => api.delete(`/takata/stocks/${id}`),

  // ─── Budget ───────────────────────────────────────────────────────────────
  getBudgets: (params) => api.get('/takata/budget', { params }),
  createBudget: (data) => api.post('/takata/budget', data),
  updateBudget: (id, data) => api.put(`/takata/budget/${id}`, data),
  validerPrevisionnel: (id) => api.post(`/takata/budget/${id}/valider-previsionnel`),
  validerFinal: (id) => api.post(`/takata/budget/${id}/valider-final`),

  // ─── Import CSV ───────────────────────────────────────────────────────────
  importVins: (data) => api.post('/takata/import', data),

  // ─── Import Excel structuré (Suzuki / format constructeur) ────────────────
  importExcel: (data) => api.post('/takata/import-excel', data),

  // ─── Import IMMATs simple (enrichit les VINs existants, ne crée pas) ──────
  importImmats: (data) => api.post('/takata/import-immats', data),

  // ─── Dépenses ─────────────────────────────────────────────────────────────
  getDepenses: () => api.get('/takata/depenses'),
  createDepense: (data) => api.post('/takata/depenses', data),
  updateDepense: (id, data) => api.put(`/takata/depenses/${id}`, data),
  deleteDepense: (id) => api.delete(`/takata/depenses/${id}`),
  presignFacture: (id, data) => api.post(`/takata/depenses/${id}/facture/presign`, data),
  confirmFacture: (id, data) => api.post(`/takata/depenses/${id}/facture/confirm`, data),
  getFactureUrl: (id) => api.get(`/takata/depenses/${id}/facture/url`),
  deleteFacture: (id) => api.delete(`/takata/depenses/${id}/facture`),
  linkDepense: (id, linked_id) => api.post(`/takata/depenses/${id}/link`, { linked_id }),
  unlinkDepense: (id) => api.post(`/takata/depenses/${id}/unlink`),

  // ─── Stats dashboard ──────────────────────────────────────────────────────
  getStats: (params) => api.get('/takata/stats', { params }),

  // ─── Factures récentes (jointure factures_services) ───────────────────────
  getFacturesRecentes: () => api.get('/takata/factures-recentes'),

  // ─── Échanges internes ───────────────────────────────────────────────────
  getEchanges: () => api.get('/takata/echanges'),
  createEchange: (data) => api.post('/takata/echanges', data),
  updateEchange: (id, data) => api.put(`/takata/echanges/${id}`, data),
  deleteEchange: (id) => api.delete(`/takata/echanges/${id}`),

  // ─── Clients connus d'un dossier ────────────────────────────────────────
  getClients: (dossierId) => api.get(`/takata/dossiers/${dossierId}/clients`),
  addClient: (dossierId, data) => api.post(`/takata/dossiers/${dossierId}/clients`, data),
  updateClient: (dossierId, clientId, data) => api.put(`/takata/dossiers/${dossierId}/clients/${clientId}`, data),
  deleteClient: (dossierId, clientId) => api.delete(`/takata/dossiers/${dossierId}/clients/${clientId}`),
  // Modifications / suppressions de fiches client, intercalées dans le Journal
  getClientsHistorique: (dossierId) => api.get(`/takata/dossiers/${dossierId}/clients-historique`),

  // ─── Casses (import VIN accidentés) ─────────────────────────────────────────
  presignCasse: (data) => api.post('/takata/casses/presign', data),
  analyzeCasse: (data) => api.post('/takata/casses/analyze', data),
  getCassesImports: () => api.get('/takata/casses/imports'),
  getCasseImport: (id) => api.get(`/takata/casses/imports/${id}`),
  deleteCasseImport: (id) => api.delete(`/takata/casses/imports/${id}`),
  deleteCassesImportsBulk: (ids) => api.delete('/takata/casses/imports', { data: { ids } }),

  // ─── Configuration permissions ────────────────────────────────────────────
  getConfig: () => api.get('/takata/config'),
  getConfigMe: () => api.get('/takata/config/me'),
  // Droits spécifiques (« rôle custom ») — super-admin uniquement
  setCapacites: (userId, capacites) => api.put(`/takata/config/${userId}/capacites`, { capacites }),
  // Poser / retirer le marquage « 1er contact » sur une entrée de journal
  setPremierContact: (contactId, est_premier_contact) =>
    api.patch(`/takata/contacts/${contactId}/premier-contact`, { est_premier_contact }),
  updateConfigUser: (userId, data) => api.put(`/takata/config/${userId}`, data),
  updateConcessionAccess: (userId, concession_ids) => api.put(`/takata/config/concession-access/${userId}`, { concession_ids }),
  grantAccess: (data) => api.post('/takata/config/grant', data),
  revokeAccess: (userId) => api.delete(`/takata/config/${userId}`),
};

export default takataApi;
